export default __webpack_public_path__ + "97737254722545b447710835da8b601e.svg";